import { Box, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

import Button from '../../../../../../components/ui/buttons/Button';
import MarketplaceCard from '../../MarketplaceCard';

type GateChoiceCardProps = {
  label: string;
  headline: ReactNode;
  taxLine?: string;
  callout?: ReactNode;
  body: ReactNode;
  detail?: ReactNode;
  buttonLabel: string;
  onSelect: () => void;
  recommended?: boolean;
  isPending: boolean;
  isDisabled: boolean;
};

const GateChoiceCard = ({
  label,
  headline,
  taxLine,
  callout,
  body,
  detail,
  buttonLabel,
  onSelect,
  recommended = false,
  isPending,
  isDisabled,
}: GateChoiceCardProps) => (
  <MarketplaceCard
    alignItems="flex-start"
    position="relative"
    flex="1"
    minW={0}
    px="24px"
    pt="24px"
    pb="26px"
    overflow="hidden"
    borderColor={recommended ? 'offerTopCardBorder' : undefined}
    boxShadow={recommended ? '0 14px 34px -20px rgba(41, 161, 125, 0.5)' : undefined}
  >
    {recommended && (
      <>
        <Box position="absolute" insetStart={0} top={0} bottom={0} w="3px" bg="leaseEndGreen" />
        <Text
          fontSize="10.5px"
          fontWeight="800"
          letterSpacing="0.1em"
          textTransform="uppercase"
          color="leaseEndGreen"
          mb="10px"
        >
          Our recommendation
        </Text>
      </>
    )}
    <Text
      fontSize="11px"
      fontWeight="700"
      letterSpacing="0.09em"
      textTransform="uppercase"
      color="grayLight"
    >
      {label}
    </Text>
    <Text
      fontSize="20px"
      fontWeight="700"
      color="leaseEndBlue"
      lineHeight="1.25"
      letterSpacing="-0.01em"
      mt="9px"
    >
      {headline}
    </Text>
    {taxLine != null && (
      <Text fontSize="11.5px" color="grayLight" lineHeight="1.5" mt="4px">
        {taxLine}
      </Text>
    )}
    {callout}
    <Text fontSize="13px" color="charcoal" lineHeight="1.55" mt="10px">
      {body}
    </Text>
    {detail}
    <Box w="100%" mt="auto" pt="18px">
      <Button
        onClick={onSelect}
        isLoading={isPending}
        isDisabled={isDisabled}
        variant={recommended ? 'primary' : 'blueOutline'}
        size="sm"
        w="100%"
        h="40px"
      >
        {buttonLabel}
      </Button>
    </Box>
  </MarketplaceCard>
);

export default GateChoiceCard;
